import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateMaterialDto = ClientInferRequest<
  typeof contract.materials.updateMaterial
>["body"];

export type UpdateMaterialResponse = ClientInferResponseBody<
  typeof contract.materials.updateMaterial,
  200
>;

export const updateMaterialApi = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateMaterialDto;
}): Promise<UpdateMaterialResponse> => {
  const response = await api.materials.updateMaterial.mutation({
    params: { id },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update material", response.status, response.body);
};
